import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import baseUrl from "../../../../api/baseUrl";

const TreatmentPieChart = React.memo(() => {
  const [chart, setchart] = useState([]);
  const [chartdata, setchartdata] = useState({
    c1: [],
    c2: [],
  });

  useEffect(() => {
    baseUrl
      .get("client/dashboard/findTreatmentPieChart")
      .then((response) => {
        setchart(response.data.data);
        setchartdata({
          c1: response.data.data,
          c2: response.data.treatmenttoday,
        });
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);
  const [select, setselect] = React.useState("month");

  // Conditional rendering to avoid rendering the PieChart if there's no data
  const handleChange = (e: any) => {
    setselect(e.target.value);
    if (e.target.value === "month") {
      setchart(chartdata.c1);
    } else {
      setchart(chartdata.c2);
    }
  };

  return (
    <div className="treatment_pie">
       <div className="header">
       <h3>chart</h3>
        <div className="form_buttons">
          <label
            htmlFor="formBtn11"
            className={select === "month" ? "active_btn" : ""}
          >
            Month
            <input
              type="radio"
              name="name1q"
              value="month"
              id="formBtn11"
              onChange={(e: any) => handleChange(e)}
            />
          </label>
          <label
            htmlFor="formBtn21"
            className={select === "week" ? "active_btn" : ""}
          >
            Week
            <input
              type="radio"
              name="name1q"
              id="formBtn21"
              value="week"
              onChange={(e: any) => handleChange(e)}
            />
          </label>
        </div>
      </div>
     <div className="chart_container">
     <PieChart
        series={[
          {
            data: chart,
          },
        ]}
        height={400}
        sx={{
          width: "100%",
          background: "white",
          marginTop: "20px",
        }}
      />
     </div>
     
    </div>
  );
});

export default TreatmentPieChart;
